import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { animate, style, transition, trigger } from '@angular/animations';
import { FormBuilder, Validators } from '@angular/forms';
import { Booking } from '../../core/models';
import { TimestampToDatePipe } from '../../core/timestamp-to-date.pipe';
@Component({
  selector: 'app-simple-booking',
  imports: [CommonModule, TimestampToDatePipe],
  standalone: true,
  template: `<div
    class="relative z-10"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      @opacity
      *ngIf="isModal"
      class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      aria-hidden="true"
    ></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        *ngIf="isModal"
        (click)="toggleModal()"
        class="fixed inset-0 pointer-events-none"
      ></div>
      <div
        class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
      >
        <div
          @opacityTranslateY
          *ngIf="isModal"
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <div>
            <div
              class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-columbus-blue-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-6 w-6 text-columbus-blue-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3
                *ngIf="newBooking.ship"
                class="text-base font-semibold leading-6 text-gray-900"
                id="ship-title"
              >
                {{ newBooking.ship.companyName }} -
                {{ newBooking.ship.shipName }}
              </h3>
              <h3
                class="text-base font-semibold leading-6 text-gray-900"
                id="booking-date"
              >
                Buchung am
                {{
                  newBooking.duration.startTime
                    | timestampToDate
                    | date: 'dd.MM.YYYY'
                }}
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Möchten Sie eine neue Buchung tätigen?
                </p>
                <p class="text-sm text-gray-500 pt-2">
                  Ausgewählte Uhrzeiten:
                  {{
                    newBooking.duration.startTime
                      | timestampToDate
                      | date: 'HH:mm' : 'UTC'
                  }}
                  -
                  {{
                    newBooking.duration.endTime
                      | timestampToDate
                      | date: 'HH:mm' : 'UTC'
                  }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3"
          >
            <button
              type="button"
              (click)="onSendValue(true)"
              class="inline-flex w-full justify-center rounded-md bg-columbus-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600 sm:col-start-2"
            >
              Bestätigen
            </button>
            <button
              type="button"
              (click)="onSendValue(false)"
              class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>`,
  styles: ``,
  animations: [
    trigger('opacity', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('opacityTranslateY', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(1rem)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateY(0)' }),
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'translateY(1rem)' }),
        ),
      ]),
    ]),
  ],
})
export class SimpleBookingComponent {
  @Input({ required: true }) newBooking!: Booking;
  @Output() close = new EventEmitter<boolean>();
  isModal = true;
  fb = inject(FormBuilder);

  toggleModal() {
    this.isModal = !this.isModal;
  }

  onSendValue(value: boolean) {
    this.close.emit(value);
  }
}
